import { z } from 'zod'
import { ApiLocale, CorporateAccountStatus } from '@library/enums'
import { enumWithEmpty } from './enum-with-empty'

/** 企業帳號 - 帳號資訊 Schema */
export const corporateAccountInfoSchema = z.object({
  /** 企業帳號ID */
  account: z.string(),
  /** 主帳號 */
  primary: z.boolean(),
  /** 啟用狀態 */
  status: z.nativeEnum(CorporateAccountStatus),
  /** 習慣語言 */
  lang: enumWithEmpty(ApiLocale),
  /** 職稱 */
  title: z.string(),
  /** 聯絡人名 */
  firstName: z.string(),
  /** 聯絡人姓 */
  lastName: z.string(),
  /** 聯絡人姓名 */
  name: z.string(),
  /** 電話國碼 */
  countryCode: z.string(),
  /** 電話 */
  phoneNo: z.string(),
  /** 分機號碼 */
  extensionNo: z.string(),
  /** E-mail */
  email: z.string(),
  /** 權限 */
  permission: z.boolean()
})

/** 企業帳號 - 帳號資訊 */
export interface CorporateAccountInfo
  extends z.infer<typeof corporateAccountInfoSchema> {}

export class CorporateAccountInfo {
  constructor() {
    return {
      account: '',
      primary: false,
      status: CorporateAccountStatus.UNVERIFIED,
      lang: '',
      title: '',
      firstName: '',
      lastName: '',
      name: '',
      countryCode: '',
      phoneNo: '',
      extensionNo: '',
      email: '',
      permission: true
    }
  }
}
